import { getPageEventName } from '@mc/pre-paywall-events'
import { getPageSource, track } from '@mc/track-event'

export type PageClickedProps = {
  location: string | undefined
  category?: string | undefined
  action: string | undefined
  type?: string | undefined
  page_source?: string | undefined
}

export const trackPageClicked = ({
  page_source: pageSource,
  ...props
}: PageClickedProps) => {
  const eventName = getPageEventName()

  track(eventName, {
    page_source: pageSource || getPageSource(),
    ...props,
  })
}
